import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type User } from '@/types';
import { type UserInitialState } from './types';

const initialState: UserInitialState = {
  user: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<User>) => {
      state.user = payload;
    },
    clearUser: (state) => {
      state.user = undefined;
    },
    setUpdatedUser: (state, { payload }: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...payload };
      }
    },
  },
});

export const { reducer: userReducer } = userSlice;
